/**
 * List of events used by acco lister widget
 *
 */
export const recommendedAccoListerEvents = {
  RECOMMENDED_ACCO_LISTER_PRINTED: 'RecommendedAccoLister.Printed',
  RECOMMENDED_ACCO_LISTER_ITEM_CLICKED: 'RecommendedAccoLister.ItemClicked',
  RECOMMENDED_ACCO_LISTER_CTA_CLICKED: 'RecommendedAccoLister.CtaClicked'
}
